import Ratings from '@components/common/ratings'
import BookTrialClassContainer from '@containers/book-trial-class/book-trial-class-container'
import { GEO_CONTENT, LANGUAGES } from '@lib/constants/geo-lp'
import dynamic from 'next/dynamic'

const DynamicCodingalLogo = dynamic(() =>
  import('@components/landing-page/geo-landing-page/first-fold/codingal-logo')
)

const { ENGLISH } = LANGUAGES
type FirstFoldProps = {
  title: JSX.Element
  description: JSX.Element
  eligibleGrades?: string
}

const FirstFold = ({ title, description, eligibleGrades }: FirstFoldProps) => {
  const {
    heroFold: { form },
  } = GEO_CONTENT[ENGLISH]

  return (
    <div className="relative lg:py-10">
      <DynamicCodingalLogo />

      <div className="z-10 relative flex flex-col items-center justify-center space-y-10 px-5 lg:px-24 lg:flex-row lg:space-x-24 mt-10 pb-5">
        <div className="flex flex-col w-full px-2 space-y-8 md:w-148 lg:px-0">
          <div className="flex flex-col items-center space-y-5 lg:items-start">
            <div className="md:block hidden pb-5">
              <Ratings isDarkText />
            </div>
            <h1 className="pt-3 md:pb-2 mt-4 text-2xl leading-7 md:leading-10 text-center font-600 md:text-5xl lg:text-left md:mt-10 lg:mt-12">
              {title}
            </h1>
            <div className="pt-1 gap-2 flex flex-wrap justify-center text-base md:text-xl">
              <span
                className="inline-block px-2 py-1 text-center rounded-md lg:text-left text-grey"
                style={{
                  background: '#E0E3FD',
                }}
              >
                {description}
              </span>
            </div>
            {eligibleGrades && (
              <div className="pt-2 gap-2 flex flex-wrap justify-center text-grey text-base md:text-xl">
                {eligibleGrades}
              </div>
            )}
          </div>
        </div>
        <div className="z-10 mt-4 lg:mt-0">
          <BookTrialClassContainer
            shouldHaveFormShadow={true}
            phoneFieldLabel={form.phoneFieldLabel}
            cta="Register for free"
            gradeFieldPlaceholder={form.gradeFieldPlaceholder}
            termsAndConditions={form.termsAndConditions}
          />
        </div>
      </div>
    </div>
  )
}
export default FirstFold
